const trackEvent = (tag) => gtag('event', 'conversion', { send_to: tag })

const trackExploreEvent = () => trackEvent('AW-529535663/EcHKCLi51eMBEK-lwPwB')

export {
  trackExploreEvent,
}
